import React, { useCallback, useState } from "react";
// @material-ui/core
import GridItem from "../../components/Grid/GridItem.js";
import GridContainer from "../../components/Grid/GridContainer.js";
import { useHistory, useLocation } from "react-router-dom";
import TextField from '@material-ui/core/TextField';

import Button from "../../components/CustomButtons/Button.js";
import { connect } from "react-redux";
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';

import { makeStyles, withStyles } from "@material-ui/core/styles";
import themeStyle from "../../assets/jss/eclipse/components/themeStyle.js";
import Danger from "../../components/Typography/Danger";
import formStyle from "../../assets/jss/eclipse/components/formStyle.js";
import { ReactComponent as ResetPasswordIcon } from '../../assets/img/icon_reset_passcode.svg'
import { ZGlobalFunctionalityApi } from "eclipse-react-sdk/services/apis/zglobal-functionality-api";
import HttpRequestConfiguration from "../../http-request-configuration.js";
import { primaryColor, primaryIconColor } from "../../style.scss";
import { SpinnerComponent } from 'react-element-spinner';
import AlertNotification from "../../components/Snackbar/AlertNotification.js";
import { load } from 'recaptcha-v3'
import { EnvConfig } from "../../environment.js";
import {
  CreateNewInputControls,
  FocusInNextControl,
  FocusInPrevControl,
  ReturnChangedControlValue,
  ReturnInputControlsConcatValues,
  ReturnInputControlsMap,
  ReturnKeyDownControlValue,
  ValidateInputControls
} from "../../password-pin.js";
import { AuthQueryParamWithTemplateId, AuthRouteWithoutTemplateId } from "../../default-route.js";

const passwordStyle = {
  oneDigitPassword: {
    '& .MuiFilledInput-root': {
      '& .MuiFilledInput-input': {
        padding: '0.8em',
        textAlign: 'center',
        fontWeight: '500'
      }
    }
  },
  customPadding: {
    paddingTop: "0em",
    paddingLeft: "0.5em",
    paddingRight: "0.5em"
  },
  firstControlCustomPadding: {
    paddingLeft: "1em",
    paddingRight: "0.15em"
  },
  secondLastCustomPadding: {
    paddingLeft: "0.5em",
    paddingRight: "0.75em"
  },
  lastControlCustomPadding: {
    paddingRight: "1em",
    paddingLeft: "0.15em",
  }
}

const passwordStyles = makeStyles(passwordStyle);
const useStyles = makeStyles(themeStyle);
const ValidationTextField = withStyles(formStyle)(TextField);


export function ResetPassword(props) {
  const identityPrefix = props?.appData?.template?.identityPrefix;
  const isIdVerifyOnForgotPassword = props?.appData?.template?.pwaAppOptions?.idVerifyOnForgotPassword;
  const passwordPINText = props?.appData?.template?.pwaAppOptions?.passwordPINText;
  const otpControlName = 'otp';
  const otpControlText = 'OTP';
  const userIdentity = useLocation().state?.userIdentity;
  const verifyOTPLength = props?.appData?.template?.pwaAppOptions?.verifyOTPLength;
  const verifyOTPControlGridLength = 12 / verifyOTPLength;

  const history = useHistory();
  const classes = useStyles();
  const passwordClasses = passwordStyles();

  const [inputs, setInputs] = useState({ ...CreateNewInputControls(otpControlName, verifyOTPLength) });
  const [errors, setErrors] = useState({});
  const [isLoading, setLoading] = React.useState(false);
  const [alertData, setAlert] = useState(null);

  const showAlert = (alertDisplay, alertType, message) => {
    setAlert({ isAlertDisplay: alertDisplay, alertType: alertType, alertMessage: message })
    setTimeout(() => {
      setAlert(null);
    }, 3000);
  }

  const redirectToErrorScreen = (fromScreen, toScreen) => {
    history.push({
      pathname: `${AuthRouteWithoutTemplateId(toScreen)}`,
      search: AuthQueryParamWithTemplateId(),
      state: { fromScreen: fromScreen }
    });
  }

  const backToLogin = useCallback (() => {
    history.replace({
      pathname: `${AuthRouteWithoutTemplateId('login')}`,
      search: AuthQueryParamWithTemplateId()
    });
  }, [history]);

  const goToCreateNewPassword = (userOTP) => {
    setLoading(true);
    const changePasswordAPI = new ZGlobalFunctionalityApi();
    changePasswordAPI.globalVerificationsPhoneGet(`${identityPrefix}-${userIdentity}`,userOTP).then(() => {
      setLoading(false);
      history.push({
        pathname: `${AuthRouteWithoutTemplateId('create-new-password')}`,
        search: AuthQueryParamWithTemplateId(),
        state: { userIdentity, userOTP }
      });
    }).catch((error) => {
      setLoading(false);
      if (error instanceof Error && error.response && error.response.data && error.response.data.length > 0 && error.response.data[0].description) {
        showAlert(true, 'ERROR', `${error.response.data[0].code} :: ${error.response.data[0].description}`);
      } else {
        redirectToErrorScreen(`/auth/login`, `error`);
    }
    });
  }

  const goToRatify = (userOTP) => {
    history.push({
      pathname: `${AuthRouteWithoutTemplateId('identity-document')}`,
      // search: AuthQueryParamWithTemplateId(),
      state: { userIdentity, userOTP }
    });
  }

  const handleInputChange = (event) => {
    event.persist();
    const inputControlValue = ReturnChangedControlValue(inputs, event.target.name, event.target.value, verifyOTPLength);
    setInputs(inputControlValue);
    const validationErrors = validateResetPasswordForm();
    setErrors(validationErrors);
  }

  const handleInputKeyUp = (event) => {
    event.persist();
    const validationErrors = validateResetPasswordForm();
    setErrors(validationErrors);
  }

  const handleOnKeyDown = (event) => {
    event.persist();
    switch (event?.key) {
      case 'Backspace':
      case 'Delete': {
        const inputControlValue = ReturnKeyDownControlValue(inputs, event.target.name, event.target.value, verifyOTPLength);
        setInputs(inputControlValue);
        const validationErrors = validateResetPasswordForm();
        setErrors(validationErrors);
        break;
      }
      case 'ArrowLeft': {
        FocusInPrevControl(event.target.name, event.target.value);
        break;
      }
      case 'ArrowRight': {
        FocusInNextControl(event.target.name, event.target.value);
        break;
      }
      default:
        break;
    }
  }

  const validateResetPasswordForm = () => {
    //Email errors
    return ValidateInputControls(inputs, otpControlName, verifyOTPLength, otpControlText, verifyOTPLength)
  }

  const handleResetPasswordFormSubmit = (event) => {
    event.preventDefault();
    const validationErrors = validateResetPasswordForm();
    const noErrors = Object.keys(validationErrors).length === 0;
    setErrors(validationErrors);
    if (noErrors) {
      // console.log('isIdVerifyOnForgotPassword :: ',isIdVerifyOnForgotPassword);
      if(isIdVerifyOnForgotPassword){
        goToRatify(`${ReturnInputControlsConcatValues(inputs, otpControlName, verifyOTPLength)}`);
      }else {
        goToCreateNewPassword(`${ReturnInputControlsConcatValues(inputs, otpControlName, verifyOTPLength)}`);
      }
    }
  }

  const generateOTP = (event) => {
    event.preventDefault();
    if (userIdentity) {
      setLoading(true);
      load(EnvConfig().GRECAPTCHA,{autoHideBadge:true}).then((reCaptcha) => {
        reCaptcha.execute('OTP_VERIFICATION').then((token) => {
          if (token) {
            //console.log("GreCaptcha Token :: ", token); // Will print the token
            const headers = { gCaptcha: token };
            const httpRequestConfiguration = HttpRequestConfiguration();
            const resetPasswordAPI = new ZGlobalFunctionalityApi(httpRequestConfiguration);
            httpRequestConfiguration.baseOptions = { headers };
            resetPasswordAPI.globalIdentitiesIdentityPasswordChangeInitPost(`${identityPrefix}-${userIdentity}`).then(() => {
              setLoading(false);
            }).catch((error) => {
              setLoading(false);
              if (error instanceof Error && error.response && error.response.data && error.response.data.length > 0 && error.response.data[0].description) {
                showAlert(true, 'ERROR', `${error.response.data[0].code} :: ${error.response.data[0].description}`);
              } else {
                redirectToErrorScreen(`/auth/login`, `error`);
              }
            });
          } else {
            showAlert(true, 'ERROR', `Please try again!`);
          }
        })
      });
    } else {
      redirectToErrorScreen(`/auth/login`, `error`);
    }
  }

  React.useEffect(() => {
    return () => {
      window.onpopstate = () => {
        backToLogin();
      }
    };
  }, [backToLogin])

  return (
    <div>
      <SpinnerComponent loading={isLoading} position="global" color={primaryColor} />
      <div className="wallet-list">
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <GridContainer>
              <GridItem xs={12} sm={12} md={12} style={{ display: 'flex' }}>
                <ArrowBackIosIcon className={classes.linkColor} onClick={backToLogin}/>
                <span className={classes.title}>Reset My {passwordPINText}</span>
              </GridItem>
            </GridContainer>
          </GridItem>
        </GridContainer>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <GridContainer>
              <GridItem xs={12} sm={12} md={12}>
                <p className={classes.textCenter + ' m-t-0 m-b-0'} style={{ fontSize: '20px' }}><b>Reset Your {passwordPINText}</b></p>
              </GridItem>
              <GridItem xs={12} sm={12} md={12} style={{ textAlign: 'center' }}>
                <ResetPasswordIcon fill={primaryIconColor} stroke={primaryIconColor} />
              </GridItem>
              <GridItem xs={12} sm={12} md={12}>
                <p className={classes.regularFontSize + ' ' + classes.textCenter + ' ' + classes.textLeft + ' m-b-0 m-t-0'}><b>Please enter the OTP sent to your registered mobile number via SMS.</b></p>
              </GridItem>
            </GridContainer>
            <GridContainer>
              <GridItem xs={12} sm={12} md={12}>
                <form onSubmit={handleResetPasswordFormSubmit}>
                  <GridContainer>
                    {ReturnInputControlsMap(otpControlName, verifyOTPLength)?.map((control) => {
                      return (
                        <GridItem key={control} xs={verifyOTPControlGridLength} sm={verifyOTPControlGridLength} md={verifyOTPControlGridLength} custom-padding={passwordClasses.customPadding}>
                          <ValidationTextField
                            inputProps={{ maxLength: verifyOTPLength > 1 ? 1 : 50, inputMode: 'numeric' }}
                            className={verifyOTPLength > 1 ? passwordClasses.oneDigitPassword : ''}
                            label={verifyOTPLength > 1 ? '' : otpControlText}
                            fullWidth
                            variant="filled"
                            id={control}
                            type="password"
                            error={!!(errors[otpControlName])}
                            name={control.substring(0, control.length - 1) + `-${control.substring(control.length - 1, control.length)}`}
                            value={inputs[control] || ""}
                            onChange={handleInputChange}
                            onKeyDown={handleOnKeyDown}
                            onKeyUp={handleInputKeyUp} />
                        </GridItem>
                      )
                    })
                    }
                    <GridItem xs={12} sm={12} md={12} className='p-t-0' style={{ paddingTop: '0 !important' }}>
                      {errors[otpControlName] && <Danger><small>{errors[otpControlName]}</small></Danger>}
                    </GridItem>
                    <GridItem xs={12} sm={12} md={12}>
                      <Button className={classes.buttonRadius} size="lg" block color="primary" type="submit" disabled={!!(errors[otpControlName])}>Next</Button>
                      <p className={classes.regularFontSize + ' ' + classes.textCenter}>Didn't receive the SMS? <span className={classes.linkColor} onClick={generateOTP}>Resend OTP</span> </p>
                    </GridItem>
                  </GridContainer>
                </form>
              </GridItem>
            </GridContainer>
          </GridItem>
        </GridContainer>
      </div>
      {alertData?.isAlertDisplay ? <AlertNotification alertData={alertData} /> : null}
    </div>
  );
}

const mapStateToProps = state => ({
  appData: state.applicationData.appData
})

export default connect(mapStateToProps)(ResetPassword)